import { Link } from "react-router-dom";
import { Breadcrumb } from "antd";

interface IPageHeaderBreadcrumb {
    items: { link: string; name: string }[];
}

const PageHeaderBreadcrumb = ({ items }: IPageHeaderBreadcrumb) => {
    return (
        <Breadcrumb className="custom-breadcrumb">
            {items.map(item => (
                <Breadcrumb.Item key={item.name}>
                    <Link to={item.link}>
                        {item.name}
                    </Link>
                </Breadcrumb.Item>
            ))}
        </Breadcrumb>
    );
}

export default PageHeaderBreadcrumb;